module.exports = __webpack_public_path__ + "img/vp.298ee87b.svg";